(function() {
  console.log('💕 script is running');

  /**
   * PDP description tabs
   */
  document.querySelectorAll('.product__description').forEach(element => {
    const tabsContent = element.innerHTML.split('<!-- split -->');

    if (tabsContent.length < 2) {
      return;
    }

    const navDom = createElementFromHTML(`<ul class="tabs-nav"></ul>`);
    const contentDom = createElementFromHTML(`<div class="tabs-content"></div>`);

    tabsContent.forEach((content, index) => {
      let titleEl = createElementFromHTML(`<div>${content}</div>`).querySelector('.tab-title');
      let tabName = titleEl ? titleEl.innerHTML : index === 0 ? 'Description' : `Tab ${index}`;

      navDom.append(createElementFromHTML(`<li><a class="${index === 0 ? 'active' : ''}" href="#tab-${index}">${tabName}</a></li>`));
      contentDom.append(createElementFromHTML(`<div class="content-item ${index === 0 ? 'active' : ''}" id="tab-${index}">${content}</div>`));
    });

    element.innerHTML = '';
    element.append(navDom, contentDom);
    initTabs(navDom);
  });

  function initTabs(navDom) {
    navDom.querySelectorAll('a').forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();

        navDom.querySelectorAll('a').forEach(itemToClear => itemToClear.classList.remove('active'));
        item.classList.add('active');

        document.querySelectorAll('.tabs-content .content-item').forEach(contentItem => {
          if (contentItem.id === item.getAttribute('href').replace('#', '')) {
            contentItem.classList.add('active');
          } else {
            contentItem.classList.remove('active');
          }
        });
      });
    });
  }

  function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
  
    return div.firstChild;
  }
})();
